import React from "react";
import { Link } from "react-router-dom";
import { Construction } from "lucide-react";

const ComingSoon = ({ section }: { section: string }) => (
  <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-32" data-testid="coming-soon">
    <div className="border border-white/10 bg-ink-surface p-12 max-w-2xl">
      <Construction className="text-neon" />
      <h1 className="mt-6 font-bebas text-5xl tracking-wide uppercase">{section}</h1>
      <p className="mt-4 text-sm text-white/50 leading-relaxed">
        This module is next in the build order. Events and Petitions are live now — jump in there
        while we wire this section up.
      </p>
      <div className="mt-8 flex gap-3">
        <Link to="/events" className="bg-neon px-6 h-11 grid place-items-center text-[12px] font-bold uppercase tracking-[0.18em] hover:pc-glow transition-shadow">
          Browse events
        </Link>
        <Link to="/petitions" className="border border-white/20 px-6 h-11 grid place-items-center text-[12px] font-bold uppercase tracking-[0.18em] hover:border-neon hover:text-neon transition-colors">
          Petitions
        </Link>
      </div>
    </div>
  </div>
);

export default ComingSoon;
